var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tips"},[_c('div',{staticClass:"vote-count"},[_vm._v(_vm._s(_vm.getText))]),_vm._v(" "),(_vm.timeText)?_c('div',{staticClass:"time"},[_vm._v(_vm._s(_vm.timeText))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }